import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/firebase-database";
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyD53p0m_6nmj-Yts8VE286uW5uXqHCuICc",
  authDomain: "looptv-c4779.firebaseapp.com",
  projectId: "looptv-c4779",
  storageBucket: "looptv-c4779.appspot.com",
  messagingSenderId: "826178336323",
  appId: "1:826178336323:web:d8c5083605abe84e2706f6",
};

class Firebase {
  constructor() {
    this.firebase = firebase;
    this.persistence = firebase.auth.Auth.Persistence.SESSION;
    this.EmailAuthProvider = firebase.auth.EmailAuthProvider;
    this.fire = firebase.apps.length
      ? firebase.app()
      : firebase.initializeApp(firebaseConfig);
  }
}
//const fire = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);
export default new Firebase();
